import firebase from "../firebase";
import generateHtml from "./generate-html";
import displayListingGenerateHtml from "../display-listing/generate-html";
import allHandeling from "../handeling-all-displays/all-handeling";
import StackDisplay from "../stack-display/display";
import spinner from "../spinner";
import homeScreen from "../home-screen/home-screen";

class displayIndSellers {

  #lastVisListingDoc = null
  #isLastListing = false
  #isLoadingListing = false


  async _displaySellerEach(sellerId) {
    this.#lastVisListingDoc = null
    this.#isLastListing = false
    this.#isLoadingListing = false
    spinner._displaySpinner("Estamos cargando el vendedor");
    let data = await firebase._getAnyDocById(`accounts/${sellerId}`);



    const sellerHtml = generateHtml._NVSellerEach(data)
    StackDisplay._display(sellerHtml);
    spinner._hideSpinner();

    this._detectNearBottom(data, 'nvSellerEachCon10ScrollCon', 100)


    const nvSellerEachCon20InsertBusinesses = document.getElementById("nvSellerEachCon20InsertBusinesses");
    const nvSellerEachCon22InsertListings = document.getElementById("nvSellerEachCon22InsertListings");


    let sellerLevel = data.sellerLevel || 'basic';
    nvSellerEachCon20InsertBusinesses.innerHTML = `
      <div class="indsellerText7">Este vendedor no tiene una Empresa en Mercado MAI</div>
    `;
    nvSellerEachCon22InsertListings.innerHTML = `
      <div class="indsellerText7">Este vendedor no tiene listados publicados en Mercado MAI en este momento</div>
    `;



    function _getOwnerBusinessId(businesses) {
      if (!Array.isArray(businesses)) return null;

      const ownerBusiness = businesses.find(
        (b) => b?.role === 'owner' && b?.id
      );

      return ownerBusiness ? ownerBusiness.id : null;
    }
    const businessIdOwn = _getOwnerBusinessId(data.businesses);

    console.log(data.businesses);

    if (data?.businesses?.length > 0) {
      nvSellerEachCon20InsertBusinesses.innerHTML = `
      <div class="indsellerText7">Cargando Empresas...</div>
    `;


      for (const [index, businessLog] of data?.businesses?.entries()) {

        if (index === 0) {
          nvSellerEachCon20InsertBusinesses.innerHTML = '';
        }

        let businessHtml = '';
        let listingsHtml = ``;

        const business = await firebase._getAnyDocById(
          `businesses/${businessLog.id}`
        );

        const { listings, lastVisibleDoc } =
          await firebase._getRecentListingsWithFilter(
            null,
            6,
            `businesses/${business.businessId}/listings`
          );

        if (listings.length < 1) {
          listingsHtml +=
            displayListingGenerateHtml._listingVerticalMiniNoListings();
        } else {
          for (const listing of listings) {
            listingsHtml += displayListingGenerateHtml._listingVerticalNV(
              listing,
              null,
              null,
              true
            );
          }
        }

        businessHtml += await displayListingGenerateHtml._generateBusiness2v(
          listingsHtml,
          business,
          'flex'
        );

        nvSellerEachCon20InsertBusinesses.insertAdjacentHTML(
          "beforeend",
          businessHtml
        );
      }
    }

    this._fillInListings(data)

  }

  async _fillInListings(data) {
    if (this.#isLastListing) return
    if (this.#isLoadingListing) return
    this.#isLoadingListing = true
    const nvSellerEachCon22InsertListings = document.getElementById("nvSellerEachCon22InsertListings");

    const { listings, lastVisibleDoc } =
      await firebase._getRecentListingsWithFilter(
        this.#lastVisListingDoc,
        5,
        `accounts/${data.userId}/listings`
      );



    if (listings?.length > 0) {
      console.log('here');
      if (!this.#lastVisListingDoc) {
        nvSellerEachCon22InsertListings.innerHTML = `
      <div class="indsellerText7">Cargando Listados...</div>
    `;
      }

      for (const [index, listing] of listings.entries()) {

        if (index === 0 && !this.#lastVisListingDoc) {
          nvSellerEachCon22InsertListings.innerHTML = ''
        }

        const ListingsHtml = displayListingGenerateHtml._listingVerticalNV(
          listing,
          false,
          "listing",
          false
        );

        nvSellerEachCon22InsertListings.insertAdjacentHTML(
          'beforeend',
          ListingsHtml
        );
      }
      this.#lastVisListingDoc = lastVisibleDoc
      nvSellerEachCon22InsertListings.insertAdjacentHTML('beforeend', homeScreen._makeAddSetToInsert());
    } else {
      console.log('here');
      this.#isLastListing = true
    }
    this.#isLoadingListing = false
  }


  _detectNearBottom(data, containerId, margin = 100) {
    const container = document.getElementById(containerId);
    if (!container) return;

    let isTriggered = false;

    container.addEventListener("scroll", () => {
      const distanceToBottom =
        container.scrollHeight -
        container.scrollTop -
        container.clientHeight;

      if (distanceToBottom <= margin) {
        // 🔒 prevent spam triggers while still near bottom
        if (!isTriggered) {
          isTriggered = true;
          this._fillInListings(data);
        }
      } else {
        // 🔓 reset when user scrolls up again
        isTriggered = false;
      }
    });
  }


  async _display(data) {

    let sellerLevel = data.sellerLevel || 'basic';

    let businessHtml = `
      <div class="indsellerText7">Este vendedor no tiene un negocio en Mercado MAI</div>
    `;
    let ListingsHtml = `
      <div class="indsellerText7">Este vendedor no tiene listados publicados en Mercado MAI en este momento</div>
    `;
    function _getOwnerBusinessId(businesses) {
      if (!Array.isArray(businesses)) return null;

      const ownerBusiness = businesses.find(
        (b) => b?.role === 'owner' && b?.id
      );

      return ownerBusiness ? ownerBusiness.id : null;
    }
    const businessId = _getOwnerBusinessId(data.businesses);

    if (sellerLevel === 'gold' || sellerLevel === 'silver' || sellerLevel === 'bronze') {
      if (businessId) {
        businessHtml = "";
        let listingsHtml = ``;
        const business = await firebase._getAnyDocById(
          `businesses/${businessId}`
        );

        const { listings, lastVisibleDoc } =
          await firebase._getRecentListingsWithFilter(
            null,
            6,
            `businesses/${business.businessId}/listings`
          );

        if (listings.length < 1) {
          listingsHtml +=
            displayListingGenerateHtml._listingVerticalMiniNoListings();
        } else {
          for (const listing of listings) {
            listingsHtml += await displayListingGenerateHtml._listingVerticalMini(
              listing,
              business.colors,
              "listingInBusiness",
              business.businessId
            );
          }
        }

        businessHtml = await displayListingGenerateHtml._generateBusiness2v(
          listingsHtml,
          business,
          'flex',
          true
        );
      }

      // const loadedListings = await firebase._getAllDocsFromPathByMostRecent(`accounts/${data.userId}/listings`, true, 5)
      // console.log(loadedListings)
      // if (loadedListings) {


      // }

      const { listings, lastVisibleDoc } =
        await firebase._getRecentListingsWithFilter(
          null,
          6,
          `accounts/${data.userId}/listings`
        );

      if (listings) {
        ListingsHtml = ''
        for (const listing of listings) {
          ListingsHtml += displayListingGenerateHtml._listingVerticalNV(
            listing,
            null,
            null,
            true
          );
        }

      }
    }

    return generateHtml._NVGenerateSeller(data, businessHtml, ListingsHtml);
  }

  async _insertSellerListings(data) {
    const sellersListingCon = document.getElementById(`${data.id}`);
    console.log(sellersListingCon);

    if (!sellersListingCon) return;

    if (data?.listings?.length > 0) {
      sellersListingCon.innerHTML = "";
      for (const listinId of data.listings) {
        const listing = await firebase._getAnyDocById(`listings/${listinId}`);

        const sellersListingHtml =
          await displayListingGenerateHtml._listingVertical(
            listing,
            allHandeling._getColors(),
            "listing",
            null
          );
        sellersListingCon.insertAdjacentHTML("beforeend", sellersListingHtml);
      }
    }
  }
}
export default new displayIndSellers();
